import type { FaireThemeEntity } from "../../entity_types/theme";

export const whimsical_gemstone_wonders: FaireThemeEntity = {
  token: "whimsical-gemstone-wonders",
  type: "theme",
  name: "Whimsical Gemstone Wonders",
  description: "Delight your gift-seeking customers with unique, hand-carved stone figures and polished double-terminated points that serve as both playful decor and spiritual talismans.",
  teaser: "As a gift shop interested in decorative figurines and novelty gifts, these unique carvings bridge the gap between your spiritual inventory and your identity as a boutique gift destination.",
  detail: "The additional_context highlights recent purchases of Green Onyx Dinosaur Carvings and Sodalite sets with velvet bags, showcasing a blend of mineral beauty and giftable charm.",
  bgColor: "#E6D5C3",
  tileBgColor: "#593c6b",
  exactProducts: true,
  retailerToken: "r_31m33roqxk",
  productTokens: [
    "p_u7w8dc24bf",
    "p_yk3kf76wx9",
    "p_fdasafff9z",
    "p_gg2cstes2q",
    "p_3jddemgqfs",
    "p_r3zvv8xbeu",
    "p_h5s45raar8",
    "p_qwzy2f6d9b",
    "p_zs5b2st3hr",
    "p_m7spxs255g",
    "p_thwqjey5su",
    "p_gb8yjw28uz",
    "p_cum42uddjz",
    "p_5hhuwgusq4",
    "p_mc6ysyjy8c",
    "p_y4h3rscwz6",
    "p_s9usr5zb2q",
    "p_5wzn9lw2y2",
    "p_6qkn45zv72",
    "p_fdwecku67j",
    "p_s8vuzth92s",
    "p_vse2q5rhd3",
    "p_andaetr3en",
    "p_d5g3fxrfs7",
    "p_sbcyq8nnzv",
    "p_er2m9n5gwr",
    "p_q4w9c6wckc",
    "p_5anmzuwm58",
    "p_9et9q4ofbo",
    "p_77tzd3hqfq",
    "p_dpnjbsfc75",
    "p_thsjvjxvmf",
    "p_sxhfejx49x",
    "p_x9zun5pes8",
    "p_d8mz68m87x",
    "p_1upyul03mt",
    "p_tx288f7usy",
    "p_267fzzhmrr",
    "p_cyp4gcrzrj",
    "p_b5bha22mjw",
    "p_wrudjxpkq2",
    "p_bvejzx5ek7",
    "p_fqggnmpyca",
    "p_kkq88ursme",
    "p_4wg3q7g74k",
    "p_2twu8afqzp",
    "p_5enmjqqyp4",
    "p_vyhbuxd2gn",
    "p_5e8pynduyx",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
